import React from "react";
import { useSelector } from "react-redux";

const YoutubeBigIcon = ({ fill }) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46.468"
      height="34.825"
      viewBox="0 0 46.468 34.825"
    >
      <path
        id="ytb_ic"
        d="M52.468,9.532A2.672,2.672,0,0,0,49.886,6.86H8.646A2.672,2.672,0,0,0,6,9.519V39.607a2.091,2.091,0,0,0,2.091,2.078h41.8a2.672,2.672,0,0,0,2.582-2.659ZM36.359,24.905,25.116,31.359a1.149,1.149,0,0,1-1.73-.968V17.832a1.149,1.149,0,0,1,1.7-.981l11.256,6.118a1.1,1.1,0,0,1,.013,1.936Z"
        transform="translate(-6 -6.86)"
        fill={fill ? fill : colors.theme}
      />
    </svg>
  );
};

export default YoutubeBigIcon;
